import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import HandleChange from './../../../../../Helpers/HandleChange';
import { useDispatch, useSelector } from 'react-redux';
import { getAllEmployees } from './../../../../../reduxToolkit/EmployeeRoles/EmployeeRolesApi';
import { toast } from 'react-toastify';
import {
    CreateRequestAccess,
    PublicCreateRequestDocument
} from '../../../../../reduxToolkit/RequestAccess/RequestAccessApi';
import {REQUEST_ACCESS_MODEL} from "../../QrRequestAccess/Model/Model";
import {PHOTO_PICKER_MODEL} from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
/**
 * RequestAccessModalApp
 * A React component that manages the state and logic for an access request modal.
 * - setModified (function): Callback to update the parent when data changes.
 * - onHide (function): Callback to close the modal.
 */
export const RequestAccessModalApp = ({ setModified, onHide, selectedList }) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { allEmployeesList } = useSelector((state) => state.EmployeeRolesSlice);

    // State that stores the form data for the access request
    const [requestData, setRequestData] = useState({});
    // State for managing the photo picker file
    const [photoPickerFile, setPhotoPickerFile] = useState({ ...PHOTO_PICKER_MODEL });
    const [disable, setDisable] = useState(false);
    const [selectedHost, setSelectedHost] = useState([]);
    const [requestAccessItem, setRequestAccessItem] = useState({...REQUEST_ACCESS_MODEL});
    const { handleChange } = HandleChange({ model: requestAccessItem, setModel: setRequestAccessItem });
    const [emptyFields, setEmptyFields] = useState(false);

    const [displayModal, setDisplayModal] = useState('');

    // Clears or resets form data
    const handleClear = () => {
        setPhotoPickerFile({ ...PHOTO_PICKER_MODEL });
        setSelectedHost([]);
        setRequestAccessItem({...REQUEST_ACCESS_MODEL});
        onHide();
    };

    // Initial data loading when component mounts
    useEffect(() => {
        dispatch(getAllEmployees());
    }, []);

    // Handles creating/submitting the request
    const handleCreate = () => {
        if (selectedHost.length === 0 || !requestAccessItem.requestReason) {
            setEmptyFields(true);
            return;
        }
        setEmptyFields(false);
        const requestAccessDto = requestAccessItem.toRegister();
        requestAccessDto.requestedById = selectedList?.[0];
        requestAccessDto.visitToId = selectedHost?.[0]?.id;

        dispatch(CreateRequestAccess(requestAccessDto)).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    const requestAccessId = data?.id;
                    createMultiple(requestAccessId)
                }
            },
        );
    };

    const createMultiple = async (requestAccessId) => {
        let files = photoPickerFile.listFiles;

        if (!files || files.length === 0) {
            handleClearFiles();
            return;
        }

        await Promise.all(
            files.map((item) => handleUploadFile(requestAccessId, item.fileSelected))
        );

        handleClearFiles()
    };

    const handleClearFiles = ()=>{
        handleClear();
        setModified(true);
        toast.success(t('has_been_requested_successfully'));
    }

    const handleUploadFile = async (requestAccessId, uploadFile) => {
        const formData = new FormData();

        if (Array.isArray(uploadFile)) {
            uploadFile.forEach((file) => {
                formData.append('fileUploadDto.files', file);
            });
        } else if (uploadFile) {
            formData.append('fileUploadDto.files', uploadFile);
        }

        formData.append('requestAccessId', requestAccessId);
        formData.append('description', requestAccessItem.requestReason);
        formData.append('fileUploadDto.userFileNames', uploadFile?.name || '');

        return dispatch(PublicCreateRequestDocument(formData));
    };

    return {
        t,
        photoPickerFile,
        setPhotoPickerFile,
        disable,
        emptyFields,
        handleCreate,
        handleClear,
        requestData,
        setRequestData,
        allEmployees: allEmployeesList,
        selectedHost,
        setSelectedHost,
        requestAccessItem, setRequestAccessItem,
        handleChange,
        displayModal, setDisplayModal
    };
};
